import { useSafeSetState } from './Hooks';
import axios from 'axios';
import Status from './Status';

const token = document.getElementById('security').getAttribute('data-value') || process.env.REACT_APP_CORE_TOKEN;

/**
 * if you don't need redux (api data won't be used outside component tree) than use this in-class axios hook
 *
 * @param basename REQUIRED
 * @param endpoint REQUIRED
 * @param method GET, POST, PUT, DELETE
 * @param data OPTIONAL
 * @param options OPTIONAL
 * @param actions OPTIONAL you can pass onSuccess or onError functions
 * @returns {*}
 */
export const useAxiosHook = (basename, endpoint, method = 'get', data, options = {}, actions = {}) => {
  const [state, setState] = useSafeSetState({ apiStatus: { status: Status.Start, errorCode: null }, data: null });
  const { onSuccess, onError } = actions;
  const run = async body => {
    setState({ apiStatus: { status: Status.Loading, errorCode: null }, data: null });
    try {
      const response = await axios({
        method,
        url: `${basename}${endpoint}`,
        headers: { Authorization: `Bearer ${token}` },
        data: data || body,
        ...options
      });
      setState({ apiStatus: { status: Status.Success, errorCode: null }, data: response.data });
      typeof onSuccess === 'function' && onSuccess();
    } catch (error) {
      setState({
        apiStatus: { status: Status.Error, errorCode: error.response ? error.response.data : null },
        data: null
      });
      typeof onError === 'function' && onError();
    }
  };
  return [state, run];
};
